export default __webpack_public_path__ + "static/alert-logic-350-cec0503b38a5ed62a732e2560b5cd404.png";